import { type RouteConfig } from 'vue-router'

export const ImportRouter: RouteConfig[] = [
  {
    path: '/import',
    component: async () => import('./Import.vue'),
  },
]
